import React, { Fragment, useState } from 'react'
import estilos from '../Zonas/ZonasListComponent.module.css'
import MapaComponent from './MapaComponent';
import LocalidadesDeLaZonaListComponent from './LocalidadesDeLaZonaListComponent';
import { useDispatch } from 'react-redux';
import { getSublocalidadesByIdLocalidad } from "../../../redux/DucksUnidadInspeccion/SublocalidadDuck";
import { useSelector } from 'react-redux'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import SubLocalidadItemComponent from './SubLocalidadItemComponent';
import SublocalidadFormComponent from './SublocalidadFormComponent';
import { deleteSublocalidad } from '../../../redux/DucksUnidadInspeccion/SublocalidadDuck'
import AsociadosDeLaLocalidadComponent from './AsociadosDeLaLocalidadComponent';


const SubLocalidadesDeLocalidadComponent = (props) => {


    const dispatch = useDispatch()
    const localidad = props.localidad
    //const sublocalidadesbase = useSelector(store => store.Sublocalidad.sublocalidades)
    const [sublocalidadesbase, setsublocalidadesbase] = React.useState([]);
    const zona = props.zona

    const [sublocalidadModify, setsublocalidadModify] = React.useState(null)
    const [anadirSublocalidad, setAnadirSublocalidad] = React.useState(false);
    const [eliminarSublocalidad, setEliminarSublocalidad] = React.useState(false);

    const [sublocalidades, setSublocalidades] = React.useState([]);

    const handleAnadirSublocalidad = () => setAnadirSublocalidad(true);
    const handleCerrarAnadirSublocalidad = () => setAnadirSublocalidad(false);

    const handleCerrarBorrarSublocalidad = () => {
        setEliminarSublocalidad(false);
    }

    React.useEffect(() => {
        dispatch(getSublocalidadesByIdLocalidad(localidad.idlocalidad)).then((res) => {
            setsublocalidadesbase(res.payload.data.data)
        })
    }, []);

    React.useEffect(() => {
        let aux = []

        sublocalidadesbase.forEach(element => {
            aux.push(element)
        });

        let hash2 = {};
        aux = aux.filter(o => hash2[o.idsublocalidad] ? false : hash2[o.idsublocalidad] = true);

        setSublocalidades(aux)

    }, [sublocalidadesbase]);

    React.useEffect(() => {
        console.log("sublocalidades: ")
        //console.log(sublocalidades)
    }, [sublocalidades]);

    const actualizarSublocalidades = () => {
        dispatch(getSublocalidadesByIdLocalidad(localidad.idlocalidad)).then((res) => {
            setsublocalidadesbase(res.payload.data.data)
            dispatch(getSublocalidadesByIdLocalidad(localidad.idlocalidad)).then((res) => {
                setsublocalidadesbase(res.payload.data.data)
                console.log(res.payload.data.data)
            })
        })
    }

    const handleEditarSubLocalidad = (sublocalidad) => {
        handleAnadirSublocalidad()
        setsublocalidadModify(sublocalidad)
    }

    const handleBorrarSubLocalidad = (sublocalidad) => {
        handleCerrarBorrarSublocalidad()
        setEliminarSublocalidad(true);
        dispatch(getSublocalidadesByIdLocalidad(localidad.idlocalidad)).then((res) => {
            setsublocalidadesbase(res.payload.data.data)
        })
        setsublocalidadModify(sublocalidad)
    }

    const borrarSublocalidad = (id) => {
        dispatch(deleteSublocalidad(id))
    }


    const style = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 1500, bgcolor: 'background.paper',
        border: '2px solid #000', boxShadow: 24, p: 4, overflow: 'scroll', height: '90%',
    };

    const HTMLmodalAnadirSublocalidad = () => {
        return (
            <Modal
                open={anadirSublocalidad}
                onClose={handleCerrarAnadirSublocalidad}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description" >
                <Box sx={style}>
                    <SublocalidadFormComponent actualizarSublocalidades={actualizarSublocalidades} handleClose={props.handleClose} onOpen={handleAnadirSublocalidad} onClose={handleCerrarAnadirSublocalidad} sublocalidadModify={sublocalidadModify} localidad={localidad} zona={zona} ></SublocalidadFormComponent>
                </Box>
            </Modal >
        )
    }

    const styleModalConfirmacion = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
        width: 500, bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24,
        p: 4, fontSize: '20px', textAlign: 'center'
    };

    const HTMLmodalBorrarSublocalidad = () => {
        return (
            <Modal
                open={eliminarSublocalidad}
                onClose={handleCerrarBorrarSublocalidad}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description" >
                <Box sx={styleModalConfirmacion}>
                    <h3>Borrar Sublocalidad</h3>
                    Estás seguro de querer borrar esta sublocalidad? <br></br>
                    Se estará borrando en cascada, es decir todo el contenido, así como sus instalaciones<br /><br />
                    <button onClick={() => borrarSublocalidad(sublocalidadModify.idsublocalidad)} className='btn btn-danger'>Si, estoy seguro</button>
                </Box>
            </Modal >
        )
    }

    return (
        <Fragment><br />
            <div className={`col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center mt-2`}>
                <div className='row'>
                    <div className='col-8' style={{ textAlign: 'left' }}>
                        <h3 className={`${estilos.tituloForm}`}>Lista de SubLocalidades de ({localidad.nombrelocalidad})</h3>
                    </div>
                    <div className='col-4' style={{ textAlign: 'right' }}>
                        <button onClick={handleAnadirSublocalidad} className='btn btn-success'>Añadir SubLocalidad</button>
                    </div>
                </div>
                <hr></hr>
                <div className='row' >
                    <div className='col-8' style={{ textAlign: 'left' }}>
                        <div style={{ height: '100vh', width: '100%' }}>
                            {
                                <MapaComponent localidades={sublocalidades} lat={localidad.latitud} lng={localidad.longitud} zoom={8} tipo={1}></MapaComponent>
                            }
                        </div>
                    </div>
                    <div className='col-4 mt-3' style={{ textAlign: 'center' }} >
                        <div style={{ overflow: 'scroll', height: '600px' }}>
                            {
                                sublocalidades.map((sublocalidad, index) => (
                                    <SubLocalidadItemComponent handleBorrarSubLocalidad={handleBorrarSubLocalidad}
                                        handleEditarSubLocalidad={handleEditarSubLocalidad}
                                        key={index} sublocalidad={sublocalidad} localidad={localidad}
                                        zona={zona}

                                    ></SubLocalidadItemComponent>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
            {HTMLmodalAnadirSublocalidad()}
            {HTMLmodalBorrarSublocalidad()}
        </Fragment>
    )
}

export default SubLocalidadesDeLocalidadComponent